export const BACK_BUTTON_TEXT = "Zurück zur Mitarbeiterliste";
export const ROLE_TEXT = "Rolle";
export const PERSONAL_DATA_TEXT = "Personendaten";
export const ROLE_DESCRIPTION =
  "Mitarbeiter mit diesen Rollen haben Zugriff auf alle Fälle (nicht nur die eigenen) und können diese entsprechend weiterbearbeiten.";
